import { createApi, fetchBaseQuery, retry } from '@reduxjs/toolkit/query/react'
import { RootState } from '../store'
import { rockefeller } from '../system/environment/Config.json'
import { MsalToken } from '../system/msal/MsalToken'
import { MsalInstance } from '../system/msal/MsalInstance'
import { TotpSessionKey } from '../shared/Constants'

const fetchBaseRockefellerNonContextApiQuery = fetchBaseQuery({
  baseUrl: rockefeller.api.baseurl,
  jsonContentType: 'application/json; charset=UTF-8;',
  prepareHeaders: async (headers: Headers, api) => {
    const state = api.getState() as RootState
    if (MsalInstance.getInstance().getAllAccounts()?.length > 0) {
      const tokenResult = await MsalToken.getAccessToken([rockefeller.api.scope])
      headers.append('Authorization', `${tokenResult.tokenType} ${tokenResult.accessToken}`)
    }
    headers.append('cache-control', 'no-cache')
    headers.append('profilejson', state.app.profileKey ?? '')
    headers.append('contextjson', state.app.contextKey ?? '')

    if (state.app.totpSessionKey) {
      headers.append(TotpSessionKey, state.app.totpSessionKey)
    }

    if (rockefeller.api.version != null && rockefeller.api.version.trim() !== '') {
      headers.append('version', rockefeller.api.version)
    }
    return headers
  }
})

const fetchBaseRockefellerNonContextApiQueryWithRetry = retry(fetchBaseRockefellerNonContextApiQuery, {
  maxRetries: 0
})

const RockefellerNonContextApiSlice = createApi({
  reducerPath: '@api/rockefellernoncontext',
  baseQuery: fetchBaseRockefellerNonContextApiQueryWithRetry,
  endpoints: () => ({}),
  keepUnusedDataFor: 60 * 60,
  tagTypes: [
    'SecurityChecklist',
    'ExternalAccountList',
    'PendingTransfers',
    'EligiblePairs',
    'ManualAssetList',
    'AllAccountBalances',
    'OtherAssets',
    'Preferences',
    'Refresh',
    'ExternalAccountUserConnections',
    'WatchList',
    'WatchListItems',
    'SummaryWidgetOrder',
    'UnReadMessages',
    'UserIdentities',
    'FetchTotpQrCode',
    'AuthMethods'
  ],
  invalidationBehavior: 'immediately'
})

export default RockefellerNonContextApiSlice
